import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { Consumer } from '@/api/bol-notifications';

export interface ConsumerDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  consumer: Consumer | null;
}

export const ConsumerDeleteDialog: React.FC<ConsumerDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  consumer,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="consumer"
      itemId={consumer?.name || ''}
      customMessage={`Are you sure you want to delete consumer "${consumer?.name}"? This will stop all notifications to this consumer. This action cannot be undone.`}
    />
  );
};